import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Button } from '@si-armes/dsfr-react';
import './BoutonFichierTelechargeable.scss';

const BoutonFichierTelechargeable = ({
    handleOnClick,
    label,
    isLoading,
    iconOnly,
    titreFichier,
    mimeType,
    contenu,
    handleHideBoutton,
    callBack,
    ...otherProps
}) => {
    const openFileBaseFromApi = () => {
        const arrayOctets = atob(contenu);
        const arrayBuffer = new Uint8Array(arrayOctets.length);

        for (let i = 0; i < arrayOctets.length; i += 1) {
            arrayBuffer[i] = arrayOctets.charCodeAt(i);
        }

        const blob = new Blob([arrayBuffer], { type: 'application/octet-stream' });
        const downloadLink = document.createElement('a');

        downloadLink.download = titreFichier;
        downloadLink.href = URL.createObjectURL(blob);
        document.body.appendChild(downloadLink);
        downloadLink.click();

        document.body.removeChild(downloadLink);
        window.URL.revokeObjectURL(downloadLink);

        if (handleHideBoutton) {
            handleHideBoutton();
        }

        if (callBack) {
            callBack();
        }
    };

    useEffect(() => {
        if (contenu && titreFichier && mimeType) {
            openFileBaseFromApi();
        }
    }, [contenu && titreFichier && mimeType]);

    return (
        <Button
            type="button"
            size="sm"
            onClick={handleOnClick}
            isLoading={isLoading}
            icon="fr-fi-file-download-line"
            iconPosition="left"
            variant="primary"
            className={!iconOnly ? 'fr-tag boutonLabel' : null}
            {...otherProps}
        >
            {label}
        </Button>
    );
};

BoutonFichierTelechargeable.defaultProps = {
    handleHideBoutton: null,
    isLoading: false,
    iconOnly: false,
    mimeType: null,
    contenu: null,
    callBack: null,
};

BoutonFichierTelechargeable.propTypes = {
    handleOnClick: PropTypes.func.isRequired,
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
    isLoading: PropTypes.bool,
    iconOnly: PropTypes.bool,
    titreFichier: PropTypes.string,
    mimeType: PropTypes.string,
    contenu: PropTypes.string,
    handleHideBoutton: PropTypes.func,
    callBack: PropTypes.func,
};

export default BoutonFichierTelechargeable;
